module.exports = __webpack_public_path__ + "assets/img/station6.2856e99c.png";